import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useDrawerData } from '../../DrawerProvider';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { getNumPages } from '../../utils';
export const DrawerThumbnailRenderWrapper = (props) => {
    const { children, isMultiPage } = props;
    const { render } = useDrawerData();
    const { isError, pageNumber, asset } = useDrawerThumbnailAsset();
    // We choose to not render top level thumbnails for failed non-hidden assets in the store
    // because multi-page dropdowns depend on the order of assets to determine where arrows show when they are expanded
    // Instead we hide the asset when it is in error (see onThumbnailAssetError in DrawerThumbnailAssetProvider)
    // But thumbnails for actual pages can fail and we don't want to hide the asset (other pages for that asset may succeed)
    // so we just hide the thumbnails for the pages
    if (isError && isMultiPage && pageNumber > 1) {
        return null;
    }
    if (!render) {
        return _jsx(_Fragment, { children: children });
    }
    return _jsx(_Fragment, { children: render(children, { isMultiPage, pageCount: getNumPages(asset) }) });
};
//# sourceMappingURL=DrawerThumbnailRenderWrapper.js.map